import { IconComponent } from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"
import { LargeViewMode, ViewMode } from "./ViewMode"

type ViewOption = {
    icon: IconComponent
    isSelected: boolean
    onSwitch: () => void
}

export const ViewSwitcher = ({
    firstOption,
    secondOption,
    title = "View",
    isLarge,
}: {
    firstOption: ViewOption
    secondOption: ViewOption
    title?: string
    isLarge?: boolean
}) => {
    const { t } = useTranslation()

    return (
        <div className="flex items-center gap-1.5">
            {title && <h5 className="mr-1 text-gray-300 select-none">{t(title)}</h5>}
            {!isLarge ? (
                <>
                    <ViewMode
                        Icon={firstOption.icon}
                        isSelected={firstOption.isSelected}
                        onClick={firstOption.onSwitch}
                    />
                    <ViewMode
                        Icon={secondOption.icon}
                        isSelected={secondOption.isSelected}
                        onClick={secondOption.onSwitch}
                    />
                </>
            ) : (
                <>
                    <LargeViewMode
                        Icon={firstOption.icon}
                        isSelected={firstOption.isSelected}
                        onClick={firstOption.onSwitch}
                    />
                    <LargeViewMode
                        Icon={secondOption.icon}
                        isSelected={secondOption.isSelected}
                        onClick={secondOption.onSwitch}
                    />
                </>
            )}
        </div>
    )
}
